var Student = "Student";
var jobRole = {
	"Job role": "Position",
	"Academic / Researcher": "Akademiker/Wissenschaftler",
	"Advisor / Consultant": "Berater/Consultant",
	"Business Executive": "Geschäftsführer",
	"Developer / Engineer": "Entwickler/Ingenieur",
	"Entrepreneur (Founder/Co-Founder)": "Unternehmer (Gründer/Mitgründer)",
	"IT Executive": "IT-Leiter",
	"IT Professional or Technical Manager": "IT-Spezialist oder Technischer Leiter",
	"Press / Media Analyst": "Journalist/Medienanalyst",
	"Sales / Marketing": "Vertriebs-/Marketingmitarbeiter",
	Student: Student,
	"Solution or Systems Architect": "Lösungs- oder Systemarchitekt",
	"System Administrator": "Systemadministrator",
	"Venture Capitalist": "Risikokapitalgeber"
};

export { Student, jobRole as default };
